import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const internalReferenceFilter = (): FilterDefinition => ({
  label: i18n.t('expenses_v2.forms.fields.reference.label'),
  type: 'search',
})
